import { SanityTwoTexts } from '../../types/generated/graphql-types'
import { TwoTextsProps } from '../components/blocks/TwoTexts'

export const mapSanityTwoTextsToTwoTextsProps = ({
  firstSubtitle,
  firstText,
  firstTitle,
  secondSubtitle,
  secondText,
  secondTitle,
}: SanityTwoTexts): TwoTextsProps => ({
  firstSubtitle: firstSubtitle ?? undefined,
  firstText: firstText ?? undefined,
  firstTitle: firstTitle ?? undefined,
  secondSubtitle: secondSubtitle ?? undefined,
  secondText: secondText ?? undefined,
  secondTitle: secondTitle ?? undefined,
})
